import React from 'react'

import { UIButton, Alert2Icon } from '@/components/ui'
import { DEFAULT_SUPPORT_MAILTO_LINK } from '@/constants'

export type AppErrorCode =
  | 'unknown'
  | 'access_denied'
  | 'app_error'
  | 'invalid_pass_setup_token'

const errorCodeTitleMap: Record<AppErrorCode, string> = {
  access_denied: 'Forbidden',
  unknown: 'Unknown Error',
  app_error: 'Oops! Sorry, something went wrong',
  invalid_pass_setup_token: 'Invalid password setup token',
}

interface AppErrorProps {
  errorCode: AppErrorCode
  errorDescription: string | undefined
  goHome: () => void
}

export const AppError = ({
  errorCode,
  errorDescription,
  goHome,
}: AppErrorProps) => {
  return (
    <main className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="">
        <div className="text-base font-semibold text-primary-500 flex flex-col items-center">
          <Alert2Icon className="size-10" />
        </div>

        <h1 className="ui w-full text-center mt-4 text-balance text-3xl font-semibold tracking-tight text-default-foreground sm:text-4xl">
          {errorCodeTitleMap[errorCode] || errorCodeTitleMap.unknown}
        </h1>

        {errorDescription && (
          <p className="mt-6 text-pretty text-lg font-normal text-foreground-500 sm:text-xl/8">
            {errorDescription}
          </p>
        )}

        <div className="mt-10 flex items-center justify-center gap-x-6">
          <UIButton color="primary" onPress={goHome}>
            Go Home
          </UIButton>
          <a
            href={DEFAULT_SUPPORT_MAILTO_LINK}
            className="text-sm font-semibold text-gray-900"
          >
            Contact support <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </main>
  )
}
